import { taskActivityReportActionType } from '../../constants/index';

export default (state = [], action) => {
  console.log('taskActivityReportReducer - Action:', action.type, 'Payload:', action.payload);
  
  switch (action.type) {
    case taskActivityReportActionType.FETCH_ACTIVITY_REPORT:
      console.log('Setting taskReport state to:', action.payload);
      return action.payload;
    default:
      return state;
  }
};
